// Should already be required, here for clarity
require('angular');

// Load Angular and dependent libs
require('angular-animate');
require('angular-aria');

// Now load Angular Material
require('angular-material');

require ('./dist/mdPickers');

module.exports = 'mdPickers';


//////////////////
// WEBPACK FOOTER
// ./~/mdPickers/index.js
// module id = 837
// module chunks = 1